import TicketsListViewTable from "./TicketsListViewTable";
export default TicketsListViewTable;
